import { apiSlice } from "./apiSlice";

export const downloadApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    createDownload: builder.mutation({
      query: (downloadData) => ({
        url: "/downloads/createDownload",
        method: "POST",
        body: downloadData,
      }),
      invalidatesTags: ["Download"],
    }),

    deleteDownload: builder.mutation({
      query: (id) => ({
        url: `/downloads/deleteDownload/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Download"],
    }),

    updateDownload: builder.mutation({
      query: ({ downloadData, id }) => ({
        url: `/downloads/updateDownload/${id}`,
        method: "PATCH",
        body: downloadData,
      }),
      invalidatesTags: ["Download"],
    }),

    getAllDownloads: builder.query({
      query: ({ page = 1, search } = {}) => {
        const params = new URLSearchParams();
        params.append("page", page);
        if (search) params.append("search", search);

        return {
          url: `/downloads/getAllDownloads?${params.toString()}`,
          method: "GET",
        };
      },

      providesTags: ["Download"],
    }),
    getDownloadById: builder.query({
      query: (id) => ({
        url: `/downloads/getDownloadById/${id}`,
        method: "GET",
      }),
    }),
  }),
});

export const {
  useCreateDownloadMutation,
  useUpdateDownloadMutation,
  useDeleteDownloadMutation,
  useGetAllDownloadsQuery,
  useGetDownloadByIdQuery,
} = downloadApi;
